// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ed86d2ca","513":"97f934df","703":"2f57ad51","787":"62306909"}[chunkId] + ".chunk.js";
};